import { render, staticRenderFns } from "./riwayatPrestasi.vue?vue&type=template&id=bf7cb694&scoped=true&"
import script from "./riwayatPrestasi.vue?vue&type=script&lang=js&"
export * from "./riwayatPrestasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7cb694",
  null
  
)

export default component.exports